import { Link } from "gatsby";
import React, { useContext, useState } from "react";
import { navigate } from "gatsby";
import NewsletterSubscriptionForm from "./common/newsletter-subscription-form";
import AuthContext from "../services/firebase/auth-context/provider";
import LoginPopup from "./common/login-popup";
import useCmsEditionAndCategory from "../hooks/use-cms-edition-and-category";
var FooterLink = function FooterLink(_ref) {
    var type = _ref.type, to = _ref.to, text = _ref.text, onClick = _ref.onClick;
    return /*#__PURE__*/ React.createElement("div", {
        className: "mb-1"
    }, type === "popup" ? /*#__PURE__*/ React.createElement("span", {
        className: "hover:text-makroOrange cursor-pointer",
        onClick: onClick
    }, text) : /*#__PURE__*/ React.createElement(Link, {
        to: to,
        activeClassName: "text-makroOrange",
        className: "hover:text-makroOrange"
    }, text));
};
var Footer = function Footer() {
    var authenticated = useContext(AuthContext)[0].authenticated;
    var _useState = useState(false), loginPopupStatus = _useState[0], setPopupStatus = _useState[1];
    var data = useCmsEditionAndCategory();
    var edition = data.allDatoCmsEdition.edges[0].node;
    var categories = data.allDatoCmsCategory.edges;
    var showLoginPopup = function showLoginPopup() {
        return setPopupStatus(true);
    };
    var navigateToAccount = function navigateToAccount() {
        return navigate("/anmelden/");
    };
    return /*#__PURE__*/ React.createElement("footer", {
        className: "pt-5 border-solid border-t-8 border-makroOrange bg-makroGreyLight flex flex-wrap"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full mb-4"
    }, /*#__PURE__*/ React.createElement(NewsletterSubscriptionForm, null)), /*#__PURE__*/ React.createElement("div", {
        className: "w-full mb-6 sm:w-1/2 sm:pr-4 lg:w-1/4"
    }, /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/abonnieren/",
        text: "Abonnieren"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        type: "popup",
        to: "",
        text: authenticated ? "Ihr Account" : "Anmelden",
        onClick: !authenticated ? showLoginPopup : navigateToAccount
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/passwort-vergessen/",
        text: "Passwort vergessen?"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/codes/",
        text: "Code einl\xF6sen"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/lesezeichen/",
        text: "Lesezeichen"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "hidden"
    }, /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/weihnachten/",
        text: "MAKROSKOP als Weihnachtsgeschenk"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "w-full mb-6 sm:w-1/2 sm:pl-4 lg:w-1/4 lg:px-2"
    }, /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/" + edition.slug + "/",
        text: "Aktuelle Ausgabe"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/themenhefte/",
        text: "Themenhefte"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/spotlight/",
        text: "Spotlight"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/alle-artikel/",
        text: "Archiv"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/alle-ausgaben/",
        text: "Alle Ausgaben"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/alle-spotlights/",
        text: "Alle Spotlights"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/edition-makroskop/",
        text: "Edition MAKROSKOP"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/podcasts/",
        text: "Podcasts"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/makronaut/",
        text: "MAKRONAUT \u2013 Das Leser-Logbuch"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-full mb-8 sm:w-1/2 sm:pr-4 lg:w-1/4 lg:px-2"
    }, categories.map(function (category, index) {
        return /*#__PURE__*/ React.createElement(FooterLink, {
            to: "/kategorien/" + category.node.name.toLowerCase() + "/artikel/",
            text: category.node.name,
            key: index
        });
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-full mb-6 sm:w-1/2 sm:pl-4 lg:w-1/4"
    }, /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/jobs/",
        text: "Jobs"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/ueber-uns/",
        text: "\xDCber uns"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/gespraechskreise/",
        text: "Gespr\xE4chskreise"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/autoren/",
        text: "Autoren"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/kontakt/",
        text: "Kontakt"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "hidden"
    }, /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/feed/",
        text: "RSS Feed"
    })), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/agb/",
        text: "AGB"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/impressum/",
        text: "Impressum"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/datenschutz/",
        text: "Datenschutz"
    }), /*#__PURE__*/ React.createElement(FooterLink, {
        to: "/autorenvereinbarung/",
        text: "Autorenvereinbarung"
    })), /*#__PURE__*/ React.createElement(LoginPopup, {
        shouldShowPopup: loginPopupStatus,
        onClose: function onClose() {
            return setPopupStatus(false);
        }
    }));
};
export default Footer;
